import { DataVersion, NeighbourAlarmsResponse } from '@hakimo-ui/hakimo/types';
import { useHttpClient, withDataVersion } from '@hakimo-ui/hakimo/util';

export function useNeighbourAlarms(
  onSuccess?: (data: NeighbourAlarmsResponse) => void,
  dataVersion?: DataVersion
) {
  const httpClient = useHttpClient();

  return (searchParams: string) => {
    const host = window.location.hostname;
    const baseUrl =
      host === 'localhost'
        ? `http://${host}:${window.location.port}`
        : `https://event-flow-${host}`;
    const url = `${baseUrl}/api/alarm_groups/neighbour_alarms?${searchParams}`;
    // Passed as a Request rather than a URL string so the version header can
    // ride along; httpClient re-wraps it with `new Request(...)`, which keeps
    // the headers.
    const request = withDataVersion(new Request(url), dataVersion);

    return httpClient<NeighbourAlarmsResponse>(request, {
      responseModifier: async (response) => {
        const respJson = await response.json();
        const payload = respJson.payload;
        if (onSuccess) {
          onSuccess(payload);
        }
        return payload;
      },
    });
  };
}

export default useNeighbourAlarms;
